import { useDateTimeContext as useDateTimeContextLegacy } from '@rtkwlf/fenrir-react';

import type { Timezone } from '@packages/fenrir/fenrir-provider/timezone';
import { useTimezoneContext } from '@packages/fenrir/fenrir-provider/timezone';

export const useTimezone = () => {
  const { timezone, muiTimezone, availableTimezones, setTimezone } =
    useTimezoneContext();

  const { setTimezone: setTimezoneLegacy } = useDateTimeContextLegacy();

  const handleSetTimezone = (value: Timezone) => {
    setTimezone(value);
    setTimezoneLegacy(value);
  };

  return {
    timezone,
    muiTimezone,
    availableTimezones,
    setTimezone: handleSetTimezone,
  } as const;
};
